<template>
  <component :is="layoutComponent" :showSidebar="showSidebar">
    <template slot="sidebar">
      <FilterList v-if="searchBar" :network="network" />
    </template>

    <!-- content starts from here-->
    <div v-if="this.$route.name == 'all-media'" class="d-block d-sm-none" style="margin-top: 40px;"></div>
    <div v-if="this.$route.name == 'network-page'" class="d-none d-md-block d-lg-none" style="margin-top: -35px;"></div>
    <div v-else class="d-none d-md-block d-lg-none" style="margin-top: 0px;"></div>
    <div class="d-none d-xxl-none d-xxl-block" style="margin-top: 40px;"></div>
    <IntroMediaSection v-if="!pageVisited" :network="network" @dismiss="markPageVisited" />
    <ResultMediaSection
      v-if="pageVisited"
      :displaySize="displaySize"
      :network="network ?? this.$store.getters['feed/getRequest']?.network ?? null"
      :searchBar="searchBar"
      :showSidebar="showSidebar"
      :media_view="media_view"
      :disableInfinityScroll="disableInfinityScroll"
      :filteredMedia="filteredMedia"
      :busy="busy"
      :pagination="pagination"
      :isFiltered="isFeedFiltered"
      class="ps-0"
      @load="load"
      @loadMore="loadMore"
    />
    <JoinNetworkCard :show="showJoinCard" :network="network" instance="showLoggedOutModal" :redirect="false" />
  </component>
</template>
<script>
import DefaultSidebarLayout from '@/views/layouts/default-sidebar/';
import NoLayout from '@/views/layouts/nolayout/';
import FilterList from './FilterList.vue';
import IntroMediaSection from './IntroMediaSection.vue';
import ResultMediaSection from './ResultMediaSection.vue';
import JoinNetworkCard from '@/components/commons/Networks/JoinNetworkCard.vue';
import { debounce, findIndex } from 'lodash';
import { mapGetters } from 'vuex';
import infiniteScroll from 'vue-infinite-scroll';

export default {
  components: {
    DefaultSidebarLayout,
    NoLayout,
    FilterList,
    IntroMediaSection,
    ResultMediaSection,
    JoinNetworkCard,
  },
  directives: { infiniteScroll },
  props: {
    network: {
      type: Object,
      default: null,
    },
    noLayout: {
      type: Boolean,
      default: false,
    },
    showSidebar: {
      type: Boolean,
      default: true,
    },
    searchBar: {
      type: Boolean,
      default: true,
    },
    columns: {
      // number of columns to occupy when rendering
      type: Number,
      default: 2,
    },
    limit: {
      // max number of items to display in the feed
      type: Number,
      default: 0,
    },
    presenter: {
      type: Object,
      default: null,
    },
    unlisted: {
      // whether or not to see unlisted items
      type: Boolean,
      default: true,
    },
    disableInfinityScroll: { type: Boolean, default: false },
    //Show Big card or Small card
    displaySize: {
      type: String,
      default: 'big',
    },
  },
  data() {
    return this.initialState();
  },
  computed: {
    layoutComponent() {
      if (this.noLayout) return 'NoLayout';
      return 'DefaultSidebarLayout';
    },
    ...mapGetters({ isAnyFilterSelected: 'feed/isAnyFilterSelected' }),
    isFeedFiltered(){
      if (this.isFiltered()) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    '$store.state.feed': {
      handler: debounce(function () {
        console.log('Feed filters updated');
        this.filterUpdateEvent();
      }, 500),
      deep: true,
    },
  },
  mounted() {
    if (!this.$auth.auth) {
      if (this.network) {
        this.showJoinCard = true;
        //this.$bus.emit('show-sign-in');
      }
    }
    this.loadPageVisited();

    // if searchbar exists then the feed is loaded after filter events are done
    if (this.pageVisited) this.load();
  },
  beforeDestroy() {
    this.$store.commit('feed/RESET_STATE');
    this.$bus.emit('reset-tag-filter');
  },
  methods: {
    initialState() {
      return {
        // the main array that holds the results to be shown
        filteredMedia: [],
        showJoinCard: false,
        busy: true,
        // A boolean that indicates whether we will "fetch" results from the
        // server on first visit to this component..
        pageVisited: false,
        pagination: {
          limit: 12,
          offset: 0,
          reached_end: false,
        },
        filters: null,
        view: 'card', // either card or list
        media_view: [
          { html: "<i class='fa fa-th'></i> " + this.$t('Main.cards'), value: 'card' },
          { html: "<i class='fa fa-list'></i> " + this.$t('Main.list'), value: 'list' },
        ],
      };
    },
    filterUpdateEvent() {
      this.pagination.offset = 0;
      this.pagination.reached_end = false;
      if (this.isAnyFilterSelected) this.markPageVisited(); // when filters update we automatically dismiss the opening help message
      this.load();
    },
    getFeedRequest() {
      let feedRequest = this.$store.getters['feed/getRequest'];
      let network = this.network ?? feedRequest?.network ?? [];
      let network_id = network ? (network[0]?.id ?? network.id) : [];
      let request = {
        offset: this.pagination.offset,
        limit: this.limit != 0 ? this.limit : this.pagination.limit,
        network_id: network_id,
        unlisted: this.unlisted,
      };
      Object.assign(request, feedRequest);
      return request;
    },
    isFiltered(){
      let feed = this.getFeedRequest();
      if (feed.dates.endDate != '' || feed.media_type.length > 0 || feed.presenter != null || feed.query != '' || feed.tag != null) {
        return true;
      } else {
        return false;
      }
    },
    load() {
      this.busy = true;
      console.log('combined request', this.getFeedRequest());
      this.$http
        .get('networks/feed', {
          params: this.getFeedRequest(),
        })
        .then(resp => {
          // store the full result count as returned by the server
          this.pagination.full_result_count = resp.data.full_result_count;

          if (resp.data.results.length === 0) {
            this.pagination.reached_end = true;
          }

          let media = resp.data.results;

          if (this.pagination.offset === 0) {
            this.filteredMedia = media;
          } else {
            // concat with a dupe check
            for (let m of media) {
              // check m.type and m.id if they already exists in our filteredMedia
              var index = findIndex(this.filteredMedia, { type: m.type, id: m.id });
              if (index === -1) this.filteredMedia.push(m);
            }
          }
          this.busy = false;
        })
        .catch(error => {
          console.error('in catch reached end!', error);

          this.pagination.reached_end = true; //disable infinite pagination because if it errored, more than likely it will error again.
          // assume the axios interceptor will handle it.
          this.busy = false;
        });
    },
    loadMore() {
      console.log('IN LOAD MORE');
      // skip to the next page
      if (this.disableInfinityScroll || this.pagination.reached_end) {
        console.log('disableInfinityScroll || this.pagination.reached_end');
        return;
      }

      // also do not requery if we have the full count of results
      if (this.pagination.full_result_count && this.filteredMedia.length >= this.pagination.full_result_count) {
        console.log('full_result_count && this.filteredMedia.length', this.filteredMedia.length, '>=', this.pagination.full_result_count);
        this.pagination.reached_end = true;
        return;
      }
      this.pagination.offset += this.pagination.limit;
      this.load();
    },
    //Set Local Variable to detect if user has visited this page previously
    loadPageVisited() {
      // Set pageVisited to true, when the user's browser has `FEED_WAS_VISITED` in the localStorage.
      this.pageVisited = localStorage.getItem('FEED_WAS_VISITED') !== null;
    },
    markPageVisited() {
      this.pageVisited = true;
      localStorage.setItem('FEED_WAS_VISITED', 'true');
      this.load(); // when user dismisses the intro page, we should trigger loading the results
    },
  },
};
</script>
<style scoped>
/* to remove header margin */
.remove-top-margin {
  margin-top: -50px;
}
</style>